import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudRadioButtonModule,
	FreudSelectModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { TabsRowModule } from 'shared/components/tabs-row/tabs-row.module';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryCGIModule } from '../../promptuary-cgi/promptuary-cgi.module';
import { PromptuaryComplianceSectionModule } from '../../promptuary-compliance-section/promptuary-compliance-section.module';
import { PromptuaryFillingInstructionsWarningModule } from '../../promptuary-instructions-filling-warning/promptuary-filling-instructions-warning.module';
import { PromptuaryNoShowModule } from '../../promptuary-no-show/promptuary-no-show.module';
import { PromptuaryOutcomeModule } from '../../promptuary-outcome/promptuary-outcome.module';
import { PromptuaryQualityDescriptionModule } from '../../promptuary-quality-description/promptuary-quality-description.module';
import { PromptuaryQualityModalModule } from '../../promptuary-quality-modal/promptuary-quality-modal.module';
import { PromptuaryQualityWarningModule } from '../../promptuary-quality-warning/promptuary-quality-warning.module';
import { PromptuaryReasonsModule } from '../../promptuary-reasons/promptuary-reasons.module';
import { PromptuaryRegisterModalComponentModule } from '../../promptuary-register-modal/promptuary-register-modal.module';
import { PromptuaryServiceEvolutionModule } from '../../promptuary-service-evolution-default/promptuary-service-evolution.module';
import { PromptuaryTaskModule } from '../../promptuary-task/promptuary-task.module';
import { SpeechToTextModule } from '../../speech-to-text/speech-to-text.module';
import { PromptuaryForm } from './promptuary-form.component';

@NgModule({
	declarations: [PromptuaryForm],
	imports: [
		CommonModule,
		SharedModule,
		TranslateModule.forChild(),
		PromptuaryReasonsModule,
		FreudButtonModule,
		PromptuaryComplianceSectionModule,
		PromptuaryCGIModule,
		PromptuaryNoShowModule,
		FreudRadioButtonModule,
		FreudSelectModule,
		SpeechToTextModule,
		FormsModule,
		FreudDialogModule,
		PromptuaryQualityModalModule,
		PromptuaryQualityWarningModule,
		PromptuaryQualityDescriptionModule,
		PromptuaryFillingInstructionsWarningModule,
		PromptuaryRegisterModalComponentModule,
		PromptuaryOutcomeModule,
		PromptuaryServiceEvolutionModule,
		PromptuaryTaskModule,
		TabsRowModule,
		ReactiveFormsModule,
	],
	exports: [PromptuaryForm],
	providers: [],
})
export class PromptuaryFormModule {}
